import { Currency } from '@shared/graphql'

import type { IconProps } from '@circlefin/components/lib/Icon'

export const getDisplayRate = (
  fromAmount: string | undefined,
  toAmount: string | undefined,
) => {
  if (!fromAmount || !toAmount) return null

  const from = Number(fromAmount)
  const to = Number(toAmount)

  if (from === 0 || Number.isNaN(from) || Number.isNaN(to)) {
    return null
  }

  // Calculate the rate as toAmount / fromAmount
  return (to / from).toFixed(4)
}

export const FX_CURRENCY_ICONS: Map<Currency, IconProps['name']> = new Map([
  [Currency.USDC, 'USDC'],
  [Currency.EURC, 'EURC'],
  [Currency.BRL, 'BR'],
  [Currency.MXN, 'MXN'],
])
